import { CanDeactivateFn } from '@angular/router';
import { VerwaltungPageComponent } from '../components/verwaltung/verwaltung-page.component';

/** Läuft auch bei reinen Query-Wechseln (Bereichswechsel, Zurück/Vor), siehe Route `/settings`. */
export const canDeactivateSettings: CanDeactivateFn<VerwaltungPageComponent> = (component) => {
  if (!component.store.aktiverBereich()?.hatUngespeicherteAenderungen()) return true;
  return component.confirmDeactivate();
};
